module.exports = __webpack_public_path__ + "static/igorschouten-cv-be20967a0f72dfb48d96d0a65cf5299a.pdf";